export const Menu = [
    {
        title: 'Home',
        to: '/',
        path: '1'
    },
    {
        title: 'About Us',
        to: '/about-us',
        path: '2'
    },

    {
        title: 'Services',
        to: '/services-details',
        path: '3',
    },
    {
        title: 'Blog',
        to: '/blog-details',
        path: '4'
    },
    {
        title: 'Pricing',
        to: '/pricing',
        path: '6'
    },
    {
        title: 'Contact Us',
        to: '/contact-us',
        path: '5'
    },
]
